import styled, { css } from 'styled-components';
import { setLayoutWidth } from 'styles/sharedStyles';

export const AppHeaderWrapper = styled.div`
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  position: relative;
  /* box-shadow: rgb(0 0 0 / 20%) 0px 4px 4px 1px; */
`;

export const AppHeaderContainer = styled.div`
  ${setLayoutWidth};

  display: grid;
  grid-template-columns: 1.5fr 1fr;
  margin: 0 auto;
  align-items: center;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    grid-template-columns: 1fr;
    padding: 1% 0%;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    padding: 1% 3% 1% 1%;
  }
`;

export const NavBarWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.down('lg')} {
    display: none;
  }
`;

export const UserActions = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  right: 0;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    justify-content: space-between;
  }
`;

export const IconsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const Title = styled.p`
  text-decoration: none;
  color: #000;
`;

const getMenuPostion = (
  left?: string,
  right?: string,
  top?: string,
  bottom?: string
) => {
  return css`
    left: ${left ? left : 'auto'};
    right: ${right ? right : 'auto'};
    top: ${top ? top : 'auto'};
    bottom: ${bottom ? bottom : 'auto'};
  `;
};

export const Menu = styled.div<{
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
}>`
  position: absolute;
  background: white;
  z-index: 5;
  box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px -3px,
    rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px;
  border-radius: ${({ theme }) => theme.borderRadius};

  right: 0px;
  transition: opacity 151ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    transform 167ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  ${({ left, right, top, bottom }) => getMenuPostion(left, right, top, bottom)}
  transform: translateY(100%);
`;
export const MenuItem = styled.div`
  padding: 10px;
  font-size: 0.95rem;
  font-weight: 400;
  &:hover {
    background: ${({ theme }) => theme.palette.grey13};
  }
  cursor: pointer;
`;

export const IconButtonWrapper = styled.div`
  position: relative;
`;

export const NotificationBadge = styled.div`
  position: absolute;
  right: -8px;
  top: -8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(250, 142, 65, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.9rem;
`;

export const IconImage = styled.img`
  width: 24px;
  height: 24px;
`;
